// extracted by css-extract-rspack-plugin
export default {"codeEditor":"kiew7","highlight":"YoeVz"};